import { Typography as JoyTypography } from '@mui/joy';
import type { TypographyProps as JoyTypographyProps } from '@mui/joy';
import { forwardRef } from 'react';
// 扩展原有的Props类型
export interface FortressTypographyProps extends Omit<JoyTypographyProps, 'level'> {
  level?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'subh1' | 'subh2' | 'subh3' | 'body1' | 'body2' | 'caption1' | 'caption2';
}

export const Typography = forwardRef<HTMLDivElement, FortressTypographyProps>(({ level = 'body1', ...props }, ref) => {
  return <JoyTypography level={level} {...props} ref={ref} />;
});

// 添加默认导出
export default Typography;
